import { markRaw } from "vue";
import { useBlockRegistry } from "../composables/useBlockRegistry";

export default defineNuxtPlugin(() => {
  const registry = useBlockRegistry();
  const modules = import.meta.glob("../components/content/**/*.vue", { eager: true });

  Object.entries(modules).forEach(([path, mod]: [string, any]) => {
    const component = mod.default;
    if (!component) return;

    const rawComponent = markRaw(component);
    const id = rawComponent.componentId || rawComponent.id || rawComponent.type;
    if (!id) return;

    registry.registerBlock({
      id,
      component: rawComponent,
      editor: typeof rawComponent.editor === "function" ? rawComponent.editor : undefined,
      icon: rawComponent.icon ?? "heroicons:cube-transparent",
      type: rawComponent.type ?? id,
      description: rawComponent.description ?? "",
      default: { ...rawComponent.default },
      categories: rawComponent.categories ?? [],
      hiddenUntilFiltered: rawComponent.hiddenUntilFiltered ?? false,
      filter: rawComponent.filter ?? [],
      order: rawComponent.order ?? 0,
      editorSections: rawComponent.editorSections ?? undefined,
      conditionStateFields: rawComponent.conditionStateFields ?? [],
      conditionActions: rawComponent.conditionActions ?? [],
    });
  });
});
